import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Marks an <ng-template> as the cell renderer for a given column key in
 * <app-data-table>. The template receives the row as `$implicit` and `row`,
 * and the column's resolved value as `value`:
 *
 *   <ng-template appDataTableCell="active" let-row let-value="value">
 *     {{ value ? 'Yes' : 'No' }}
 *   </ng-template>
 *
 * A column without a matching template renders its plain resolved value.
 */
@Directive({
  selector: '[appDataTableCell]',
})
export class DataTableCellDirective {
  /** Column key this template renders. */
  @Input('appDataTableCell') key!: string;

  constructor(public template: TemplateRef<unknown>) {}
}
